import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsCheck2Square, BsXCircle } from "react-icons/bs";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { FcMoneyTransfer } from "react-icons/fc";
import { extractDate } from "../../../Components/Functions/date.fun";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { getId } from "../../../Components/Functions/word.fun";

const ViewReqForPayment = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [dataHistory, setDataHistory] = useState();
  const [refresh, setRefresh] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  let { id } = useParams();
  const navigate = useNavigate();
  const [imageInfo, setImageInfo] = useState({
    name: "",
    url: "",
  });
  const duplicateRequest = () => {
    navigate(`/req-for-payment/new?duplicate=${id}`);
  };
  const [modalData, setModalData] = useState();
  const handelSubmit = (info) => {
    setModalData(info);
    document.getElementById("open-modal").click();
  };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/request/getreqpaymentByID/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.reqStatus);
          setDataHistory(res?.data?.relatedRequests);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  useEffect(() => {
    if (data?.vendor) {
      performRequest(
        "GET",
        `/request/getreqforpayment?page=1&vendorName=${data.vendor}`
      )
        .then((res) => {
          if (res.status === 201) {
            // setData(res?.data?.reqStatus);

            let dt = [];
            if (data.poNum) {
              dt = res?.data?.reqForPayments?.sort((a, b) => {
                if (a.poNum === data.poNum) return -1;
                if (b.poNum === data.poNum) return 1;
                return getId(b.poNum) - getId(a.poNum);
              });
            } else if (data.siKitForClientId) {
              dt = res?.data?.reqForPayments?.sort((a, b) => {
                if (a.siKitForClientId === data.siKitForClientId) return -1;
                if (b.siKitForClientId === data.siKitForClientId) return 1;
                return b.siKitForClientId - a.siKitForClientId;
              });
            }

            setPaymentHistory(dt);
          } else {
            Toast("error", "Error while getting PO!");
          }
          setLoading(false);
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [data]);

  const handelPaymentAproval = () => {
    performRequest("PATCH", `/request/updateStatus/${id}`, {
      status: true,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Payment Approved successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const handelRejectPayment = () => {
    performRequest("PATCH", `/request/updateStatus/${id}`, {
      paymentRejectStatus: true,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Reject Payment successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const returnClassname = (isApproved) => {
    return isApproved
      ? "badge bg-success  text-white"
      : "badge bg-danger  text-white";
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcMoneyTransfer></FcMoneyTransfer>Request For Payment
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Request For Payment</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Payment For :</label>
                  <div className="w-100 col">
                    {(data?.paymentfor || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Invoice / Pi / Quotation :
                  </label>
                  <div className="w-100 col">
                    {data?.invoiceImg ? (
                      <LazyImageComponent
                        width="70%"
                        src={data.invoiceImg}
                        alt="Invoice photo"
                      />
                    ) : (
                      "Invoice photo Not Available"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">GRN :</label>
                  <div className="w-100 col">
                    {data?.uploadGRN ? (
                      <LazyImageComponent
                        width="70%"
                        src={data.uploadGRN}
                        alt="GRN photo"
                      />
                    ) : (
                      "GRN Not Available"
                    )}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Amount :</label>
                  <div className="w-100 col">
                    {(data?.amount || "N/A")}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vedor Reduce Amount :
                  </label>
                  <div className="w-100 col">
                    {(data?.reduceVendorAmount || "N/A")}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    {data?.poNum ? "PO Number :" : "SI Kit For Client :"}
                  </label>
                  <div className="w-100 col">
                    {(data?.poNum
                      ? data?.poNum?.replace(/\//g, " ")
                      : data?.siKitForClientId
                      ? data?.siKitForClient
                      : "N/A"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Invoice / PI Number :
                  </label>
                  <div className="w-100 col">
                    {(data?.invoicenumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data?.paymentType === "Remaining Payment" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Remaining Payment Invoice / PI Number :
                  </label>
                  <div className="w-100 col">
                    {(data?.remainingInvoicenum || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data?.vendor && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Vendor</label>
                  <div className="w-100 col ">
                    <a
                      className="cursor-pointer"
                      href={`/purchase-vendor-management/view-vendor/${data?.vendor}`}
                    >
                      View
                    </a>
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes :</label>
                  <div className="w-100 col">
                    {(data?.notes || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              <hr className="mt-2 mb-2"></hr>
              <h2 className="m-0 pt-2 pb-2">Bank Details</h2>
              <hr className="mt-2 mb-2"></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Accountholder Name :
                  </label>
                  <div className="w-100 col">
                    {(data?.accountholderName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Bank Name :</label>
                  <div className="w-100 col">
                    {(data?.bankName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Account Number :
                  </label>
                  <div className="w-100 col">
                    {(data?.accountNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3"> IFSC code :</label>
                  <div className="w-100 col">
                    {(data?.ifcCode || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              <br></br>

              {data?.lineItems?.length > 0 && <hr className="mt-2 mb-2"></hr>}
              {data?.lineItems?.length > 0 && <h2>Line Items</h2>}
              {data?.lineItems?.length > 0 && <hr className="mb-0"></hr>}
              {data?.lineItems?.length > 0 && (
                <div className="table-responsive">
                  {data && (
                    <table className="table table-vcenter">
                      <thead>
                        <tr>
                          <th>PARTICULARS</th>
                          <th>Item Unit</th>
                          <th>Item Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.lineItems?.map((lineItem, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {(lineItem?.particulars || "N/A").toUpperCase()}
                              </td>
                              <td>
                                {(lineItem?.itemUnit || "N/A").toUpperCase()}
                              </td>
                              <td>
                                {(
                                  lineItem?.itemQuantity || "N/A"
                                ).toUpperCase()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
              {/* <hr />
              <h2>Payment history</h2>
              <hr />
              <div className="table-responsive">
                {dataHistory && (
                  <table className="table table-vcenter">
                    <thead>
                      <tr>
                        <th>Payment Type</th>
                        <th>Amount</th>
                        <th>Payment Img</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataHistory?.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {(item?.paymentType || "N/A").toUpperCase()}
                            </td>
                            <td>{(item?.amount || "N/A").toUpperCase()}</td>
                            <td>
                              {item?.paymentImg ? (
                                <LazyImageComponent
                                  width="40%"
                                  src={item.paymentImg}
                                  alt="Payment Image"
                                />
                              ) : (
                                "Payment Image Not Available"
                              )}
                            </td>
                            <td>
                              <span className={returnClassname(item?.status)}>
                                {item?.status ? "Approved" : "Pending"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div> */}
              {dataHistory && dataHistory.length > 0 && (
                <>
                  <hr />
                  <h2>Advanced Items history</h2>
                  <hr />
                  <div className="table-responsive">
                    {
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            <th>Payment Type</th>
                            <th>Name</th>
                            <th>HSN</th>
                            <th>Item Unit</th>
                            <th>Item Price</th>
                            <th>Item Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataHistory
                            ?.filter(
                              (req) =>
                                req.paymentType === "Advanced Payment" &&
                                data.paymentType !== "Advanced Payment"
                            ) // ✅ only advanced payments
                            ?.flatMap((req) =>
                              req.lineItems?.map((subItem, index) => (
                                <tr key={`${req.id}-${index}`}>
                                  <td>{req.paymentType}</td>
                                  <td>{subItem.particulars || "-"}</td>
                                  <td>{subItem.hsn || "-"}</td>
                                  <td>{subItem.itemUnit || "-"}</td>
                                  <td>{subItem.itemPrice || "-"}</td>
                                  <td>{subItem.itemQuantity || "-"}</td>
                                </tr>
                              ))
                            )}
                        </tbody>
                      </table>
                    }
                  </div>
                </>
              )}

              {paymentHistory?.length > 0 && (
                <>
                  <div>
                    <hr />
                    <h3>Payment history</h3>
                    <hr />
                    <div
                      style={{ maxHeight: "300px" }}
                      className="table-responsive"
                    >
                      <table className="table table-vcenter fs-5">
                        <thead>
                          <tr>
                            {[
                              "req id",
                              "paymentfor / date",
                              "Amount (-GST)",
                              "paymentType / poNum",
                              "creator",
                              "paymentPhoto",
                              "status",
                              // "description",
                            ]?.map((item, index) => {
                              return <th key={index}>{item}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {paymentHistory?.map((item) => {
                            return (
                              <tr
                                key={item?.id}
                                className={
                                  (item?.poNum &&
                                    item?.poNum === data?.poNum) ||
                                  (item?.siKitForClientId &&
                                    item?.siKitForClientId ===
                                      data?.siKitForClientId)
                                    ? "bg-green-lt"
                                    : ""
                                }
                              >
                                <td>
                                  <span
                                    className="text-blue text-decoration-underline cursor-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/req-for-payment/view/${item?.id}`
                                      )
                                    }
                                  >
                                    {item?.id}
                                  </span>
                                </td>
                                <td>
                                  <span>{item?.paymentfor}</span>
                                  <br />
                                  {extractDate(item?.createdAt) || "N/A"}
                                </td>
                                <td>{roundOffCost(item?.amount)}</td>
                                <td>
                                  {item?.paymentType || "N/A"} <br />
                                  <span
                                    className="cursor-pointer text-decoration-underline"
                                    onClick={() => {
                                      if (item.poNum) {
                                        navigate(
                                          `/purchase-order/view/${getId(
                                            item.poNum
                                          )}`
                                        );
                                      } else if (item?.siKitForClientId) {
                                        navigate(
                                          `/revenue-management/edit/${item.siKitForClientId}`
                                        );
                                      }
                                    }}
                                  >
                                    {item.poNum
                                      ? item.poNum
                                      : item?.siKitForClientId
                                      ? item.siKitForClientId
                                      : "N/A"}
                                  </span>
                                </td>

                                <td>{item?.genratedByName}</td>
                                <td>
                                  {item?.paymentImg ? (
                                    <button
                                      data-bs-toggle="modal"
                                      data-bs-target="#modal-scrollable"
                                      onClick={() =>
                                        setImageInfo({ url: item?.paymentImg })
                                      }
                                      className="btn btn-sm btn-info p-0 px-1"
                                    >
                                      View Img
                                    </button>
                                  ) : (
                                    "N/A"
                                  )}
                                </td>

                                <td>
                                  <span
                                    className={returnClassname(item?.status)}
                                  >
                                    {item?.status ? "Approved" : "Pending"}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  className="btn mx-1 mt-2 btn-primary"
                  onClick={handelPaymentAproval}
                  disabled={data?.status || data?.paymentRejectStatus}
                >
                  <BsCheck2Square className="fs-2 me-2" /> APPROVE REQUEST
                </button>
                {/* <SimpleButton
                  buttonText={"generate pdf"}
                  href={`/delivery-challan/preview/${id}`}
                /> */}
                <button
                  disabled={data?.status || data?.paymentRejectStatus}
                  onClick={() => {
                    navigate(`/req-for-payment/edit/${id}`);
                  }}
                  className="btn mx-1 mt-2 btn-primary"
                >
                  {" "}
                  <BsCheck2Square className="fs-2 me-2" />
                  EDIT REQUEST FOR PAYMENT
                </button>
                <SimpleButton
                  buttonText="Duplicate"
                  onClick={duplicateRequest}
                />

                <button
                  disabled={data?.status || data?.paymentRejectStatus}
                  onClick={handelRejectPayment}
                  className="btn mx-1 mt-2 btn-primary bg-danger"
                >
                  <BsXCircle className="fs-2 me-2" /> REJECT PAYMENT
                </button>

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
            <div
              className="modal modal-blur fade"
              id="modal-scrollable"
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{imageInfo.name}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body p-4">
                    <LazyImageComponent
                      width={700}
                      src={imageInfo.url}
                      alt="not uploaded"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewReqForPayment;
